import { useEffect, useState } from "react";
import { decryptAESCBC } from "util/encryption";
import { getTpStreamToken } from "store/actions/contentList";
export function useTpStreamToken(videoId) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchToken = async () => {
    if (!videoId) return;

    try {
      setIsLoading(true);
      setError(null);

      const encrypted = await getTpStreamToken(videoId);

      try {
        const decrypted = decryptAESCBC(encrypted);
        const parsed = JSON.parse(decrypted);
        setData(parsed);
      } catch (err) {
        console.error("Decrypt failed", err);
        setData(null);
      }
    } catch (err) {
      console.error("TPStream token fetch failed", err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchToken();
  }, [videoId]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchToken,
  };
}
